var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54999 1.52026C2.61666 0.694475 0.711102 2.73979 1.7111 4.56635L5.5611 11.6101C5.80555 12.064 6.2611 12.3648 6.77777 12.4304L16.5555 13.6335C16.7444 13.6554 16.8889 13.814 16.8889 13.9999C16.8889 14.1859 16.7444 14.3445 16.5555 14.3664L6.77777 15.5695C6.2611 15.6351 5.80555 15.9414 5.5611 16.3898L1.7111 23.4335C0.711102 25.2601 2.61666 27.3054 4.54999 26.4796L29.1 16.007C30.8833 15.2468 30.8833 12.7531 29.1 11.9929L4.54999 1.52026Z",
    fill: "#007CF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconActive);
export default __webpack_public_path__ + "static/media/SendIconActive.5c56965f8af6a944ba64472020751789.svg";
export { ForwardRef as ReactComponent };